/*
 * Copyright (c) 2026. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { fromGender } from "@/src/services/formServiceFunctions";

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "@/src/components/Form/Common/Style/summaryStyle";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";
import { isFlexServiceProduct } from "@/src/services/advocardService.tsx";

type PersonalDataProps = {
  formData: AbstractCase | Record<string, any>;
  product: AbstractCase;
};

const PersonalData = ({ formData, product }: PersonalDataProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}>Persönliche Angaben</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"gender"} />
        Anrede
      </Grid>
      <Grid size={12}>
        {fromGender(formData.client.gender) || "Keine Anrede"}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"givenName"} />
        Vorname
      </Grid>
      <Grid size={12}>
        {formData.client.givenName}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"familyName"} />
        Nachname
      </Grid>
      <Grid size={12}>
        {formData.client.familyName}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"telephone"} />
        Telefonnummer
      </Grid>
      <Grid size={12}>
        {formData.customer.telephone}
      </Grid>
      {!isFlexServiceProduct(product) && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"insurancePolicyNumber"} />
            Versichertennummer
          </Grid>
          <Grid size={12}>
            {formData.caseInsurance.insurancePolicyNumber}
          </Grid>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"caseReferenceNumber"} />
            Schadennummer
          </Grid>
          <Grid size={12}>
            {formData.caseInsurance.caseReferenceNumber}
          </Grid>
        </>
      )}
    </>
  );
};

export default PersonalData;
